// Udemy-style homepage content for Learnwithinfobloom

export const trendingSkills = [
  { name: 'Artificial Intelligence', image: 'https://images.unsplash.com/photo-1677442136019-64780df7b3b2?w=320&h=180&fit=crop' },
  { name: 'Python', image: 'https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=320&h=180&fit=crop' },
  { name: 'Microsoft Power BI', image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=320&h=180&fit=crop' },
  { name: 'IT Agility & Agile', image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=320&h=180&fit=crop' },
  { name: 'AWS Certification', image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=320&h=180&fit=crop' },
  { name: 'Project Management', image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=320&h=180&fit=crop' },
  { name: 'UI/UX Design', image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=320&h=180&fit=crop' },
  { name: 'Digital Marketing', image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=320&h=180&fit=crop' },
];

export const testimonials = [
  {
    quote: 'Learnwithinfobloom helped me transition from NYSC to a full-time tech role with confidence.',
    name: 'Chinedu Okafor',
    course: 'Full Stack Web Development',
  },
  {
    quote: 'The lessons are clear, practical, and tailored to the Nigerian market. I got my first remote job after completing the program.',
    name: 'Aisha Bello',
    course: 'DevOps & Cloud Engineering',
  },
  {
    quote: 'As a working mum, the flexibility made it easy to learn data analysis in the evenings and weekends.',
    name: 'Ngozi Adeyemi',
    course: 'Data Analytics Bootcamp',
  },
  {
    quote: 'From zero experience to building real projects — the instructors and community support are top-notch.',
    name: 'Tunde Akinwale',
    course: 'React & Next.js from Zero to Hero',
  },
];

export const certifications = [
  { name: 'CompTIA IT fundamentals', logo: 'CompTIA' },
  { name: 'AWS Certified: Cloud Architect', logo: 'AWS' },
  { name: 'PMI Agile Certified Practitioner', logo: 'PMI' },
];

export const careerAccelerators = [
  {
    title: 'Full Stack Web Developer',
    students: '167,000 students',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop',
  },
  {
    title: 'Digital Marketer',
    students: '89,000 students',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=300&fit=crop',
  },
  {
    title: 'Data Scientist',
    students: '124,000 students',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=300&fit=crop',
  },
];

export const popularSkills = {
  featured: { label: 'ChatGPT is a top skill', link: 'See ChatGPT courses', count: '9,999+ courses' },
  development: [
    { name: 'Python', count: '12,000' },
    { name: 'Web Development', count: '8,500' },
    { name: 'Data Science', count: '6,200' },
  ],
  design: [
    { name: 'Blender', count: '2,100' },
    { name: 'Graphic Design', count: '5,400' },
    { name: 'User Experience Design', count: '3,800' },
  ],
  business: [
    { name: 'PMP Project Management Professional (PMP)', count: '4,100' },
    { name: 'Microsoft Power BI', count: '3,200' },
    { name: 'PMP Certified Associate in Project Management (CAPM)', count: '1,900' },
  ],
};

export const footerLinks = {
  topCategories: ['Development Courses', 'Web Development', 'Project Management', 'Data Science', 'Business Courses', 'IT & Software', 'Personal Development', 'Design', 'Marketing'],
  certificationsByRole: ['Cybersecurity Certifications', 'Project Management Certifications', 'Cloud Certifications', 'Data Analytics Certifications', 'HR Management Certifications', 'Real Estate Certifications'],
  webDevelopment: ['JavaScript', 'React JS', 'Node.js', 'Angular', 'Vue'],
  dataScience: ['Python', 'Machine Learning', 'MySQL', 'Deep Learning'],
  itCertifications: ['Amazon AWS', 'AZ-900 Microsoft Azure Fundamentals', 'PMI-ACP Certified Practitioner', 'SC-900 Microsoft Security, Compliance, and Identity Fundamentals', 'CompTIA Security+'],
  communications: ['Presentation Skills', 'Public Speaking', 'Writing', 'PowerPoint'],
  about: ['About us', 'Contact us', 'Blog', 'Careers'],
  businessIntelligence: ['Microsoft Excel', 'Power BI', 'SQL', 'Tableau', 'Google Analytics'],
};

export const partnerLogos = ['Nasdaq', 'Samsung', 'Cisco', 'Volkswagen', 'VMWare', 'Citi', 'SAP'];
